import React from "react";

export const LoginInfo = ({ closeBox }) => (
	<div>
		<div className="form-tooltip-veil" onClick={closeBox} />
		<div
			className="form-tooltip-content quickpay-instructions-tooltip"
			onClick={closeBox}>
			<div className="dx-col">
				<div className="tooltip-close">
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M2 17.972L17.972 2m0 15.972L2 2"
							strokeWidth="3"
							fill="none"
							strokeLinecap="round"
						/>
					</svg>
				</div>
				<div className="tooltip-header" />
				<div className="tooltip-body">
					<p>
						<img src="media/icons/quickpay_tooltip.png" alt="billing account number help"/>
					</p>
					<p id="tip-billing-acct-number">
						Your billing account number is listed on your invoice.
						Check the top-right corner, or the “Account Summary”
						section.
					</p>
				</div>
			</div>
		</div>
	</div>
);



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/LoginInfo/LoginInfo.js